import { useState, useEffect } from 'react';

type PropsType = {
  seconds: number;
  onTick: (num: number) => void;
  onComplete: () => void;
};

export default function CountDown(props: PropsType) {
  const { seconds, onTick, onComplete } = props;
  const [countdown, setCountdown] = useState(seconds);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prevCountdown) => {
        onTick(prevCountdown - 1);

        if (prevCountdown === 1) {
          clearInterval(timer);
          onComplete();
        }

        return prevCountdown - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [seconds]);
  return <div>{countdown}s</div>;
}
